import { render, staticRenderFns } from "./AjaxLoading.vue?vue&type=template&id=1856bb67&scoped=true"
import script from "./AjaxLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./AjaxLoading.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AjaxLoading.vue?vue&type=style&index=0&id=1856bb67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856bb67",
  null
  
)

export default component.exports